import React, { useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { testimonials } from '../data/homepage';
const MAX_SLIDES = 3;
export function Testimonials() {
  const slides = testimonials.slice(0, MAX_SLIDES);
  const [index, setIndex] = useState(0);
  const reduce = useReducedMotion();
  const multi = slides.length > 1;
  const current = slides[index];
  const go = (dir: number) => setIndex(i => (i + dir + slides.length) % slides.length);
  return <section aria-labelledby="testimonial-heading" className="bg-navy py-24 text-paper md:py-32" data-id="element-134" data-mp="2x0jl4doavja8">
      <h2 id="testimonial-heading" className="sr-only" data-id="element-135" data-mp="2s1ymujslz9of">
        What veterans say
      </h2>
      <Reveal className="mx-auto max-w-4xl px-6 text-center md:px-10" data-id="element-136" data-mp="v96k3zpgdvjg">
        <div role="region" aria-roledescription="carousel" aria-label="Testimonials" data-id="element-137" data-mp="v7c8xd3zhhsk">
          <span aria-hidden="true" className="block font-serif text-8xl leading-none text-gold md:text-9xl" data-id="element-138" data-mp="qb51ffvxvy8i">
            “
          </span>
          <div className="relative min-h-[14rem] md:min-h-[12rem]" aria-live="polite" data-id="element-139" data-mp="m4rmy9btd84u">
            <AnimatePresence mode="wait" initial={false} data-id="element-140" data-mp="77s6rx2wc6yr">
              <motion.figure key={index} role="group" aria-roledescription="slide" aria-label={`${index + 1} of ${slides.length}`} initial={reduce ? false : {
              opacity: 0,
              y: 8
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={reduce ? {
              opacity: 0
            } : {
              opacity: 0,
              y: -8
            }} transition={{
              duration: 0.25,
              ease: [0.23, 1, 0.32, 1]
            }} data-id="element-141" data-mp="79bntpwdmm1l">
                <blockquote className="font-serif text-2xl font-medium leading-snug md:text-4xl md:leading-snug" data-id="element-142" data-mp="v4xvrhwkhjxo">
                  {current.quote}
                </blockquote>
                <figcaption className="mt-10 flex items-center justify-center gap-4 text-base font-semibold tracking-[0.15em] text-gold" data-id="element-143" data-mp="1nm0kd25ov5y9">
                  <span aria-hidden="true" className="h-px w-8 bg-gold" data-id="element-144" data-mp="1xgxv8z0chnh5" />
                  {current.attribution.toUpperCase()}
                  <span aria-hidden="true" className="h-px w-8 bg-gold" data-id="element-145" data-mp="1sjpbitzjtbds" />
                </figcaption>
              </motion.figure>
            </AnimatePresence>
          </div>

          {multi && <div className="mt-12 flex items-center justify-center gap-6" data-id="element-146" data-mp="1jhy6lrcu18kz">
              <button type="button" onClick={() => go(-1)} aria-label="Previous testimonial" className="flex h-12 w-12 items-center justify-center rounded-full border border-paper/30 transition-colors duration-150 ease-out hover:border-gold hover:text-gold" data-id="element-147" data-mp="1ejwq9e6sjnd7">
                <ChevronLeftIcon className="h-6 w-6" data-id="element-148" data-mp="10px3udwxsy6a" />
              </button>
              <div className="flex gap-3" data-id="element-149" data-mp="vrvjzqrosutr">
                {slides.map((_, i) => <button key={i} type="button" onClick={() => setIndex(i)} aria-label={`Show testimonial ${i + 1}`} aria-current={i === index} className={`h-2.5 w-2.5 rounded-full transition-colors duration-150 ease-out ${i === index ? 'bg-gold' : 'bg-paper/40'}`} data-id="element-150" data-mp="qu2fr39y2aw4" data-mpi={i} />)}
              </div>
              <button type="button" onClick={() => go(1)} aria-label="Next testimonial" className="flex h-12 w-12 items-center justify-center rounded-full border border-paper/30 transition-colors duration-150 ease-out hover:border-gold hover:text-gold" data-id="element-151" data-mp="2jrh9p3p5elh0">
                <ChevronRightIcon className="h-6 w-6" data-id="element-152" data-mp="2xjxd45lyolig" />
              </button>
            </div>}
        </div>
      </Reveal>
    </section>;
}